import { X, Download, Printer, FileText } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

interface ContractReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string;
  contractTitle?: string;
}

export function ContractReviewModal({
  isOpen,
  onClose,
  pdfUrl,
  contractTitle = "Review Contract",
}: ContractReviewModalProps) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "contract.pdf";
    link.click();
  };

  const handlePrint = () => {
    const iframe = document.getElementById(
      "contract-pdf-frame"
    ) as HTMLIFrameElement;
    iframe?.contentWindow?.print();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
      style={{
        width:"80%",
        height:"90%",
        flexDirection:'column',
        display:'flex',
backgroundColor:"#f8fafc"
      }}
        className="tailwind-prefix contract-review-dialog max-w-[80vw] w-full h-[90vh] p-0 bg-slate-50 flex flex-col"
      >
        {/* Header */}
        <DialogHeader style={{
            height:80,
        }} className="flex flex-row items-center justify-between border-solid border-l-0 border-r-0 border-t-0 px-6 py-4 border-b ">
          <div className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-slate-600" />
            <div className="text-base font-semibold">
              {contractTitle}
            </div>
          </div>

         
        </DialogHeader>

        {/* PDF Viewer */}
        <div className="flex-1 p-4 -mt-4  overflow-hidden">
          <div className="w-full h-full bg-white rounded-lg border shadow-sm overflow-hidden">
            <iframe
              id="contract-pdf-frame"
              src={`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
              className="w-full h-full"
              title={contractTitle}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
